import {RootState} from '../../store';
import {RatePlan} from './types';

export const selectionSelector = (state: RootState): Record<string, RatePlan> =>
    state['rate-plans'].selection as Record<string, RatePlan>;
